"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Modal = _interopRequireDefault(require("../Modal/Modal"));
var _Button = require("../../Elements/Button/Button");
var _Text = require("../../Elements/Text/Text");
var _pictogram = _interopRequireDefault(require("../../Elements/pictogram/pictogram"));
var _jsxRuntime = require("react/jsx-runtime");
// import Image from '../../Components/Image/Image';

// import {  useState } from 'react';
const HeroModal = ({
  modalArgs,
  onHide,
  show,
  data,
  size,
  isRtl
}) => {
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Modal.default, {
    ...modalArgs,
    ...data,
    show: show,
    onHide: onHide,
    size: size,
    isRtl: isRtl,
    dialogClassName: "-centerAlign",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_Modal.default.Header, {
      closeButton: modalArgs.closeButton,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_pictogram.default, {
        className: "-modalImage",
        size: data.icon.size,
        name: data.icon.name
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.Text, {
        type: "overline",
        content: data.overline,
        isHTML: true
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Modal.default.Title, {
        children: data.title
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Modal.default.Body, {
      children: data.text
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Modal.default.Footer, {
      children: data.buttons.map(button => {
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.Button, {
          text: button.text,
          onClick: button.onClick || onHide,
          variant: button.variant
        });
      })
    })]
  });
};
var _default = exports.default = HeroModal;
module.exports = exports.default;